import React, {useState} from 'react';
import {Box, Button, Grid} from '@mui/material';
import {Link} from 'react-router-dom';
import AIThinkingLoader from '../../../components/ai/investigate/common/AIThinkingLoader';

const AiThinkingLoaderDemo: React.FC = () => {
  const [isThinking, setIsThinking] = useState<boolean>(false);
  return (
    <Box className="ai-thinking-demo">
      <h1>AiThinkingLoader</h1>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <hr />
      <Button
        onClick={() => setIsThinking((prev: any) => !prev)}
        data-testid="aithinking-loader-demo-button">
        {`${isThinking ? 'Stop' : 'Start'} AI Thinking`}
      </Button>
      <hr />
      <Grid
        container
        spacing={2}
        height={400}
        paddingTop={10}
        className="thinking-loader-box"
      >
        <Grid size={20}>
          <AIThinkingLoader open={isThinking} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AiThinkingLoaderDemo;
